import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/process/private";

const ProcessApi = new ApiService(ROOT_URL, "", {
  startProcessByName: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/startprocessbyname", data, onSuccess, onError);
  },
  getAllByVisible: function(ctx, onSuccess, onError) {
    this.apiGET(ctx, "/getallbyvisible?visible=true", onSuccess, onError);
  },
  getAllByLead: function(ctx, leadId, onSuccess, onError) {
    this.apiGET(ctx, "/getallbylead?leadId=" + leadId, onSuccess, onError);
  },
  listActualProcesses: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/listactual", data, onSuccess, onError);
  },
  listAllActualProcesses: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/listallactual", data, onSuccess, onError);
  },
  addNote: function(ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/add-note", data, onSuccess, onError);
  },
  getAllByCurrentUserIdAndAssigneeId: function (ctx, assigneeId, currentUserId, domainId, onSuccess, onError) {
    this.apiGET(ctx, "/getAllByCurrentUserIdAndAssigneeId?currentUserId=" + currentUserId + (assigneeId != null ? "&assigneeId=" + assigneeId : "") + "&domainId=" + domainId, onSuccess, onError);
  }
});

export default ProcessApi;



// WEBPACK FOOTER //
// ./src/service/ProcessService.js